import { useMockQueryHotReload } from "@/mock-api/useQueryHotReload.ts";
import { queryClientAtom } from "@/modules/api/queryClient.ts";
import { SelectedCurrencyProvider } from "@/modules/currency/CurrencyContext.tsx";
import BaseRouterRoot from "@/modules/main/BaseRouterRoot.tsx";
import { MobileLayoutSwitch } from "@/modules/main/mobile/MobileLayoutSwitch.tsx";
import QueryPrefetch from "@/modules/main/QueryPrefetch.tsx";
import { UserErrorContext } from "@/modules/user/UserErrorContext.ts";
import { isBuiltRelease } from "@/utils/environment.ts";
import { QueryClientProvider } from "@tanstack/react-query";
import { useAtomValue } from "jotai/react";
import type { ReactNode } from "react";

export function AuthenticatedRootProviders({
    children,
    prefetch = false,
}: {
    children: ReactNode;
    prefetch?: boolean;
}) {
    const queryClient = useAtomValue(queryClientAtom);

    useMockQueryHotReload(queryClient);

    return (
        <QueryClientProvider client={queryClient}>
            <UserErrorContext />
            <SelectedCurrencyProvider>
                {
                    // Only prefetch in release (to prevent console spam in development)
                    // NB: This should stay below the auth guard because it can trigger authenticated requests.
                    prefetch && isBuiltRelease && <QueryPrefetch />
                }
                {children}
            </SelectedCurrencyProvider>
        </QueryClientProvider>
    );
}

function MainRoot() {
    return (
        <AuthenticatedRootProviders prefetch>
            <BaseRouterRoot Layout={MobileLayoutSwitch} chatEnabled />
        </AuthenticatedRootProviders>
    );
}

export default MainRoot;
